import { Injectable } from '@angular/core';
import { UsuarioLogado } from '../models/usuario-logado.model';
import { Router } from '@angular/router';
import { EmpresaResponse } from '../models/response/empresa-response.model';
import { UsuarioResponse } from '../models/response/usuario-response.model';
import { LoginResponse } from '../models/response/login-response.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private weblab_token: string = 'weblab_token';
  private weblab_usuario: string = 'weblab_usuario';
  private weblab_empresa: string = 'weblab_empresa';

  email: string; // Vem da tela de login;

  private tokenExpiradoSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private router: Router) { }

  canActivate(): boolean {
    return !!this.obterTokenUsuario;
  }

  salvarToken(token: LoginResponse) {
    localStorage.setItem(this.weblab_token, token.token_jwt);

  }

  salvarUsuarioLogado(email: string, usuarioResponse: UsuarioResponse) {
    localStorage.setItem(this.weblab_usuario, JSON.stringify({
      nome: usuarioResponse.usuario_oticomlab,
      email: email,
      empresa: usuarioResponse.empresa_usuario_oticomlab
    } as UsuarioLogado));
  }

  salvarEmpresa(empresa: EmpresaResponse) {
    localStorage.setItem(this.weblab_empresa, JSON.stringify(empresa));
  }

  logout() {
    let empresa = this.obterEmpresa;

    localStorage.removeItem(this.weblab_token);
    localStorage.removeItem(this.weblab_usuario);

    this.tokenExpiradoSubject.next(false);
    this.router.navigate(['/', empresa.token_acesso]);
  }

  limparCacheEmpersa() {
    localStorage.removeItem(this.weblab_empresa);
  }

  tokenExpiradoEmit(value: boolean) {
    this.tokenExpiradoSubject.next(value);
  }

  obterTokenExpirado() {
    return this.tokenExpiradoSubject;
  }

  get obterUsuarioLogado(): UsuarioLogado {
    return localStorage.getItem(this.weblab_usuario)
      ? JSON.parse(localStorage.getItem(this.weblab_usuario) as string)
      : null;
  }
  get obterEmailUsuarioLogado(): string | null {
    return localStorage.getItem(this.weblab_usuario)
      ? (JSON.parse(localStorage.getItem(this.weblab_usuario) as string) as UsuarioLogado).email
      : null;
  }
  get obterTokenUsuario(): string {
    return localStorage.getItem(this.weblab_token) ?? 'null';
  }

  get obterEmpresa(): EmpresaResponse {
    return localStorage.getItem(this.weblab_empresa)
      ? JSON.parse(localStorage.getItem(this.weblab_empresa) as string)
      : null;
  }
}
